<div class="page">
  <section class="card force-password-card">
    <div class="overline">Security Required</div>
    <h1>Change your temporary password</h1>
    <p class="lede">
      Your current password was reset by an administrator. Update it now to
      continue using the platform.
    </p>

    <form [formGroup]="form" class="password-form" (ngSubmit)="submit()">
      <mat-form-field
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
      >
        <mat-label>Current temporary password</mat-label>
        <input
          matInput
          formControlName="currentPassword"
          [type]="hideCurrentPassword ? 'password' : 'text'"
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideCurrentPassword = !hideCurrentPassword"
          [attr.aria-label]="
            hideCurrentPassword ? 'Show password' : 'Hide password'
          "
        >
          <ng-icon
            [name]="hideCurrentPassword ? 'HeroEye' : 'HeroEyeOff'"
          ></ng-icon>
        </button>
        @if (form.get("currentPassword")?.hasError("required")) {
          <mat-error>Current password is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
      >
        <mat-label>New password</mat-label>
        <input
          matInput
          formControlName="newPassword"
          [type]="hideNewPassword ? 'password' : 'text'"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideNewPassword = !hideNewPassword"
          [attr.aria-label]="
            hideNewPassword ? 'Show password' : 'Hide password'
          "
        >
          <ng-icon
            [name]="hideNewPassword ? 'HeroEye' : 'HeroEyeOff'"
          ></ng-icon>
        </button>
        @if (form.get("newPassword")?.hasError("required")) {
          <mat-error>New password is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
      >
        <mat-label>Confirm new password</mat-label>
        <input
          matInput
          formControlName="confirmNewPassword"
          [type]="hideConfirmNewPassword ? 'password' : 'text'"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideConfirmNewPassword = !hideConfirmNewPassword"
          [attr.aria-label]="
            hideConfirmNewPassword ? 'Show password' : 'Hide password'
          "
        >
          <ng-icon
            [name]="hideConfirmNewPassword ? 'HeroEye' : 'HeroEyeOff'"
          ></ng-icon>
        </button>
        @if (form.get("confirmNewPassword")?.hasError("required")) {
          <mat-error>Confirm password is required.</mat-error>
        }
        @if (passwordsDoNotMatch()) {
          <mat-error>Passwords do not match.</mat-error>
        }
      </mat-form-field>

      <div class="actions">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="!form.valid || submitting"
        >
          @if (!submitting) {
            <span>Update Password</span>
          } @else {
            <span>Updating...</span>
          }
        </button>
      </div>
    </form>
  </section>
</div>
